import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedDate, FormattedMessage } from 'react-intl';
import get from 'lodash/get';

import ProductCover from 'Components/Utility/ProductCover';
import Drm from 'Components/Utility/Drm';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';
import FormatProductName from 'Helpers/Format/FormatProductName';

const BundleExitOfferModalItem = ({ item }) => {
  if (!item) return false;

  const {
    cover,
    out,
    type,
    slug,
    drm,
    tiers,
    os,
    releaseDate,
    display_type: displayType,
    cover_type: coverType,
  } = item;

  const renderValidPlatforms = () => {
    const validPlatforms = Object.keys(drm).filter(d => drm[d]);
    const platforms = validPlatforms.filter(platform => platform !== 'voucher');

    if (platforms?.length > 0) {
      return (
        <Drm drmType={platforms[0]} colorOverride="light" iconSize="small" className="mr-3" />
      );
    }
    return false;
  };

  const name = FormatProductName(item.name, type);
  const today = new Date().getTime();
  const releaseTime = new Date(releaseDate).getTime();
  const price = get(out, 'discountPrice', 0);

  return (
    <div className="bundle-exit-offer-modal-item">
      <div className="bundle-exit-offer-modal-item-content">
        <div className="d-none d-md-block">
          <div className="item-image">
            <ProductCover
              thumbnail
              cover={cover}
              alt={`Product cover for ${name}`}
              displayType={displayType}
              coverType={coverType}
            />
          </div>
        </div>
        <div className="item-container">
          <div className="item-details">
            <div className="item-name">
              <Link to={`/${type}/${slug}`}>
                {name}
              </Link>
            </div>
            <div className="d-flex align-items-center">
              {drm &&
                <div>
                  {renderValidPlatforms()}
                </div>
              }
              <div className="os-icons">
                {os && os.windows &&
                  <FontAwesomeIcon icon={['fab', 'windows']} className="mr-1" />
                }
                {os && os.mac &&
                  <FontAwesomeIcon icon={['fab', 'apple']} className="mr-1" />
                }
                {os && os.linux &&
                  <FontAwesomeIcon icon={['fab', 'linux']} className="mr-1" />
                }
              </div>
            </div>
          </div>
          <div className="item-price">
            {out && (out.price !== out.discountPrice) && (!tiers || item.is_srp_bundle) &&
              <div className="was-price">
                <del>
                  {
                    <SpecialFormattedNumber
                      value={out.price / 100}
                      style="currency"
                    />
                  }
                </del>
              </div>
            }
            <div className="now-price">
              <SpecialFormattedNumber
                value={price / 100}
                style="currency"
              />
            </div>
          </div>
        </div>
      </div>
      {releaseTime > today &&
        <div className="preorder-message">
          <FormattedMessage id="bundle-exit-offer-modal-item.pre-order" defaultMessage="Pre-Order: To be released" />
          &nbsp;
          <FormattedDate value={releaseDate} year="numeric" month="short" day="2-digit" />
        </div>
      }
    </div>
  );
};

BundleExitOfferModalItem.propTypes = {
  item: PropTypes.shape({
    cover: PropTypes.string,
    out: PropTypes.shape({
      discountPrice: PropTypes.number,
      price: PropTypes.number,
    }),
    type: PropTypes.string,
    slug: PropTypes.string,
    drm: PropTypes.object,
    tiers: PropTypes.arrayOf(PropTypes.object),
    os: PropTypes.shape({
      windows: PropTypes.bool,
      mac: PropTypes.bool,
      linux: PropTypes.bool,
    }),
    releaseDate: PropTypes.string,
    display_type: PropTypes.string,
    cover_type: PropTypes.string,
    _id: PropTypes.string,
    tierIndex: PropTypes.number,
    name: PropTypes.string,
    is_srp_bundle: PropTypes.bool,
  }),
};

BundleExitOfferModalItem.defaultProps = {
  item: null,
};

export default BundleExitOfferModalItem;
